export default "__VITE_ASSET__DsdbQqFK__"